export function canQueryData() {
    return window.navigator.onLine;
}
//# sourceMappingURL=canQueryData.js.map